import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.08 11.18a1.73 1.73 0 0 1-.84-1.47V6.9a4.52 4.52 0 0 0-3.58-4.44.79.79 0 0 0 .12-.41.72.72 0 0 0-1.44 0 .79.79 0 0 0 .12.41A4.52 4.52 0 0 0 3.88 6.9v2.81a1.71 1.71 0 0 1-.83 1.46.75.75 0 0 0 .35 1.42h9.32a.75.75 0 0 0 .36-1.41Zm-8-.09a3.19 3.19 0 0 0 .31-1.38V6.9a3 3 0 0 1 2.68-3 2.92 2.92 0 0 1 2.68 3v2.81a3.19 3.19 0 0 0 .31 1.38Zm4.24 2.28a1.13 1.13 0 0 1-1.25 1.25 1.13 1.13 0 0 1-1.25-1.25h2.5Z';
const draw24px =
  'M12,22.36a1.8,1.8,0,0,1-2-2h4A1.8,1.8,0,0,1,12,22.36Zm8.19-3.67a.75.75,0,0,1-.72.57H4.53a.75.75,0,0,1-.35-1.42,3.21,3.21,0,0,0,1.56-2.73V10.59a6.75,6.75,0,0,1,5.77-6.73,1.15,1.15,0,1,1,1,0,6.75,6.75,0,0,1,5.76,6.73v4.52a3.2,3.2,0,0,0,1.57,2.73A.75.75,0,0,1,20.19,18.69Zm-2.61-.93a4.56,4.56,0,0,1-.83-2.65V10.59A5.15,5.15,0,0,0,12,5.33a5.16,5.16,0,0,0-4.76,5.26v4.52a4.56,4.56,0,0,1-.83,2.65Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BellIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'bell'),
) as IconWithRender;

BellIcon.displayName = 'BellIcon';
BellIcon.propTypes = Icon.propTypes;
BellIcon.renderIcon = (props) => <BellIcon {...props} />;
export default BellIcon;
